
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert"

interface EmailDebugInfoProps {
  error: any
  emailDebugInfo: any
}

export function EmailDebugInfo({ error, emailDebugInfo }: EmailDebugInfoProps) {
  if (!error) return null;
  
  return (
    <Alert variant="warning" className="text-xs text-amber-600 mt-2 p-2 bg-amber-50 rounded">
      <AlertTitle className="font-semibold">Email System Notice:</AlertTitle>
      <AlertDescription>
        Receipt email may not send, but your payment will still be processed.
        <details className="mt-1">
          <summary className="cursor-pointer text-xs">Debug Details</summary>
          <pre className="whitespace-pre-wrap text-xs mt-1">
            {JSON.stringify({
              emailResponse: error,
              debug: emailDebugInfo
            }, null, 2)}
          </pre>
        </details>
      </AlertDescription>
    </Alert>
  )
}
